<template>
  <div class="login-page">
    <div class="container">
      <div class="columns">
        <div class="column is-6 is-offset-3">
          <div style="text-align: center">
            <img src="@/assets/logo.png" style="width: 150px" />
          </div>
          <h1 class="title has-text-centered">Área Administrativa</h1>
          <login-form
            :onSubmit="Login"
            :is-disabled="disableLoginForm"
            :is-loading="disableLoginForm"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from '../forms/LoginForm'
import { LoginUser } from '../../api/user'
import { getCookie, createCookie } from '../../helpers'

export default {
  name: 'loginPage',
  components: { LoginForm },
  data () {
    return {
      disableLoginForm: false
    }
  },
  methods: {
    async Login (data) {
      try {
        this.disableLoginForm = true
        const success = await LoginUser(data)
        createCookie('redecienciaToken', success.data.token, 7)
        document.redecienciaToken = success.data.token
        this.$router.push('/pt')
        this.disableLoginForm = false
      } catch (error) {
        console.log(error.response)
        if (error.response.status === 401) {
          this.$notify.open({
            type: 'danger',
            content: 'Usuário e/ou senha inválidos',
            duration: 10000
          })
        }
        if (error.response.status === 500) {
          this.$notify.open({
            type: 'danger',
            content: 'Não foi possível fazer Login: erro interno do Servidor (500)',
            duration: 10000
          })
        }
        this.disableLoginForm = false
      }
    }
  },
  created () {
    if (getCookie('redecienciaToken')) {
      console.log('login tem cookie')
      this.$router.push('/pt')
    }
  }
}
</script>

<style lang="scss">
.login-page {
  margin-top: 100px
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LoginPage.vue